module.exports = __webpack_public_path__ + "static/media/Scatterbug_gaussian2.3bfca86e.png";